import { useEffect, useRef } from 'react'
import type { FormInstance } from 'antd/es/form/Form'
import type { CourseLinkGroupOption } from '../CourseLinkGroupSelect/CourseLinkGroupSelect'
import {
  getGroupPerLessonDefaultsFromGroup,
  getGroupPerLessonLinkFieldDefaults,
} from './groupPerLessonLink.utils'

type UseGroupPerLessonLinkFormParams = {
  form: FormInstance
  isActive: boolean
  selectedTariff?: ICourseTariff | null
  groupIdWatch: number | null
  selectedCourseGroup?: CourseLinkGroupOption | null
  /** Сброс «цена вручную» у individual/lesson price-блока. */
  onDefaultsApplied?: () => void
}

/**
 * Оркестрация group_per_lesson в create-link:
 * смена/снятие группы → lesson_duration / first_price из группы или тарифа.
 */
export const useGroupPerLessonLinkForm = ({
  form,
  isActive,
  selectedTariff,
  groupIdWatch,
  selectedCourseGroup,
  onDefaultsApplied,
}: UseGroupPerLessonLinkFormParams) => {
  const prevGroupIdForDefaultsRef = useRef<number | null>(null)

  useEffect(() => {
    if (!isActive || !selectedTariff) {
      prevGroupIdForDefaultsRef.current =
        groupIdWatch == null ? null : Number(groupIdWatch)
      return
    }

    const prevGroupId = prevGroupIdForDefaultsRef.current
    prevGroupIdForDefaultsRef.current =
      groupIdWatch == null ? null : Number(groupIdWatch)

    if (groupIdWatch == null) {
      if (prevGroupId != null) {
        form.setFieldsValue(getGroupPerLessonLinkFieldDefaults(selectedTariff))
        onDefaultsApplied?.()
      }
      return
    }

    if (!selectedCourseGroup) return

    form.setFieldsValue(
      getGroupPerLessonDefaultsFromGroup(selectedTariff, selectedCourseGroup),
    )
    onDefaultsApplied?.()
  }, [
    form,
    groupIdWatch,
    isActive,
    onDefaultsApplied,
    selectedCourseGroup,
    selectedTariff,
  ])
}
